import includes from "lodash-es/includes"
import { useNetworkState } from "react-use"
import type { IUseNetworkState } from "react-use/lib/useNetworkState"

function useIsNetworkFast(): boolean {
    const networkState: IUseNetworkState = useNetworkState()

    return !includes(["slow-2g", "2g"], networkState.effectiveType) && networkState.online
}

export { useIsNetworkFast }
